
<template>
<div>
  <div class="lds-facebook"  v-if="!loading"><div></div><div></div><div></div></div>
 <div class="row" v-if="loading">
      <div class="col-md-7 col-12" style="background:#ECECEC; padding:0px">
      <a-card title="Meeting Details" :bordered="false" style="width: auto">
        <a-descriptions>
          <a-descriptions-item label="Meeting Name">
            <b>{{meeting.topic}}</b>
          </a-descriptions-item>
          <a-descriptions-item label="Status">
               <b>{{meeting.status}}</b>
          </a-descriptions-item>
          <a-descriptions-item label="Start Time">
             <b>{{meeting.start_time}}</b>
          </a-descriptions-item>
          <a-descriptions-item label="Start Meeting">
            <a :href="meeting.start_url">Start</a>
          </a-descriptions-item>
          <a-descriptions-item label="Join Url">
            <a-input v-model="meeting.join_url"/>
          </a-descriptions-item><br>
          <a-descriptions-item label="Description">
            <b> {{meeting.agenda}}</b>
          </a-descriptions-item>
          <a-descriptions-item label="Meeting Password">
            <b> {{meeting.password}}</b>
          </a-descriptions-item>
        </a-descriptions>
      </a-card>
      <br>
       <Recordings></Recordings>
      </div>
      <div class="col-md-5 col-12">
          <Registrants></Registrants>
      </div>
 </div>
</div>
</template>


<script>
import API from '../services/api';
import Registrants from '../components/Registrants.vue'
import Recordings from '../components/Recordings.vue'
import moment from 'moment'
export default {
  components:{Registrants,Recordings},
  data() {
    return {
      meeting:{},
      meeting_id: this.$route.params.id,
      visible: false,
      disabledDate(current) {
        return current && current < moment().endOf('day');
      },
      avaliable:false,
      loading:false
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    }
  },
  created() {
    if(!this.loggedIn) {
      this.$router.push('/login');
      return;
    }
    this.getMeeting()
  },
  methods: {
    moment,
    async getMeeting(){
      await API.get(`/meetings/${this.meeting_id}`)
      .then(({data,status}) => {
        if(status == 404){
          this.openNotification("Gabim!","This meeting dont exist anymore!")
          return;
        }
        this.meeting = data.meeting
        this.avaliable = true;
        this.loading = true
      })
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      this.participants.push(this.participant)
      API.post(`/meetings/${this.meeting_id}/registrants`,{participants:this.participants})
      .then(({data}) => {
          this.getRegistrants()
      })
      this.onReset()
      this.visible = false;
    },
    handleCancel(e) {
      this.visible = false;
    },
    openNotification(message,description) {
      this.$notification.open({
        message: message,
        description: description,
      });
    }
  }
};
</script>